module.exports = function() {
  return new Worker(__webpack_public_path__ + "407e9d831f354fae2e9c.worker.js");
};